import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortBy } from 'lodash';
import { MarketData, Markets } from '../models/markets';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfig, ENVIRONMENT_CONFIG } from '@ipreo/northstar';
import moment from 'moment';

const EQUITIES_DISPLAY_NAMES = new Map<string, string>(
  new Array<[string, string]>(
    ['DIA', 'Dow ETF (DIA)'],
    ['USO', 'Oil ETF (USO)'],
    ['GLD', 'Gold ETF (GLD)'],
    ['MUB', 'Muni ETF (MUB)'],
    ['SPY', 'S&P 500 ETF (SPY)']
  )
);

const PREFERED_EQUITIES_ORDER = ['SPY', 'DIA', 'USO', 'GLD', 'MUB'];

@Injectable()
export class MarketsService {
  private muniApiHost: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.muniApiHost = config.params.muniApiHost as string;
  }

  public fetchData(date: Date): Observable<Markets> {
    const requestedDate: string = moment(date).format('MM-DD-YYYY');

    return this.http
      .get(`${this.muniApiHost}/equities/quotes?date=${requestedDate}`)
      .pipe(map((res: MarketData[]) => this.equitiesToViewModel(res)));
  }

  public equitiesToViewModel(equities: MarketData[]): Markets {
    return sortBy<MarketData>(equities, (equity) =>
      PREFERED_EQUITIES_ORDER.indexOf(equity.symbol)
    ).map((equity) => ({
      symbol: equity.symbol,
      displayName: EQUITIES_DISPLAY_NAMES.get(equity.symbol),
      price: equity.lastPrice,
      change: equity.lastPrice - equity.yesterdayClosePrice
    }));
  }
}
